import angular from 'angular';
import React from 'react';
import ReactDOM from 'react-dom';
import ContentAreaDisplay from '../../component/ContentAreaDisplay';

angular.module('checkout').directive('rcmCartContentAreaDisplay', [ () => ({
    link(scope, element, attrs) {
        ReactDOM.render(
            React.createElement(
                ContentAreaDisplay,
                { areaName: attrs?.areaName || null }
            ),
            element[0]
        );
        scope.$on('$destroy', () => {
            ReactDOM.unmountComponentAtNode(element[0]);
        });
    },
})]);
